import React from 'react';
import { useAsync } from 'react-use';
import cn from 'classnames';
import { IBaseSection, IContent } from 'src/interface';
import { getWithPath } from 'src/utils/http';
import { ALIGN_TYPE, Icon, LIST_TYPE, Section } from 'src/components';
import RouterLink from 'src/components/links';
import { TitleWrap } from 'src/modules/shared/components/TitleWrap';
import MoreSection from 'src/modules/shared/components/sections/MoreSection';
import { ContentList } from '../../list';
import styles from './styles.module.scss';

interface IProps extends IBaseSection<IContent> {
    type?: LIST_TYPE;
    alignList?: ALIGN_TYPE;
    alignItem?: ALIGN_TYPE;
    ContentItemComponent?: React.FunctionComponent<any>;
    id: number;
    trackingKey?: string;
}

export function ContentTopicSection(props: IProps) {
    const {
        items = [],
        title,
        link = '',
        className = 'topic-section',
        displayTimeIn,
        alignList,
        alignItem,
        type,
        ContentItemComponent,
        id,
        trackingKey = '|topic',
        options,
    } = props;

    if (!items.length) {
        return null;
    }

    const renderOptions = () => {
        if (!options?.more?.url) {
            return null;
        }
        const state = useAsync(() => getWithPath(options?.more?.url, {}));

        const data = state.value?.data as any;

        const sections = {
            items: [data],
        } as any;
        return <>{data && <MoreSection {...sections} />}</>;
    };
    const linkTitle = id === 593 ? '/bong-da/giai-dau/world-cup/1.epi' : link; // wc

    return (
        <Section
            className={cn(
                styles[className],
                styles[`topic-${id}`],
                'mt-[12px] p-[16px] ml-[-20px]',
                'w-[calc(100%+40px)]',
                'bg-[#fdf6f4]',
            )}
        >
            <TitleWrap
                title={title}
                link={linkTitle}
                renderAs="h2"
                className={cn(
                    'relative',
                    'text-[2.2rem]',
                    'leading-[30px]',
                    'mb-[8px]',
                    'uppercase',
                    'text-[#db562b]',
                    'after:absolute',
                    'after:bottom-[8px] after:left-0',
                    'after:w-full after:h-[2px]',
                    'after:bg-[#db562b]',
                    'font-[900]'
                )}
                classNameLink={cn(
                    'relative z-[2]',
                    'bg-[#fdf6f4]',
                    'pr-[15px]',
                )}
            />
            {renderOptions()}
            <ContentList
                {...props}
                items={items}
                align={alignList}
                alignItem={alignItem}
                type={type}
                displayTimeIn={displayTimeIn}
                ContentItemComponent={ContentItemComponent}
                tracking={id ? trackingKey + id : ''}
            />
            <RouterLink to={link} className={styles['view-all']}>
                <span>Xem thêm tin</span>
                <Icon icon="dots" />
            </RouterLink>
        </Section>
    );
}

export default React.memo(ContentTopicSection);
